import { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';
import auth from './api/auth';
import { useParams } from 'react-router-dom';
// Components
import Loading from './components/Loading/Loading'
import Navbar from './components/Navbar/Navbar';

import Login from './containers/Authentication/Login';
import ResetPassword from './containers/Authentication/ResetPassword';
import ResetPasswordConfirm from './containers/Authentication/ResetPasswordConfirm';
import StudyDetails from './containers/StudyDetails/StudyDetails';
import StudyList from './containers/StudyList/StudyList';
import GlobalRegistries from './containers/GlobalRegistries/GlobalRegistries';
import Interventions from './containers/Interventions/Interventions';
import Dashboard from './containers/Dashboard/Dashboard';
import Analytics from './containers/Analytics/Analytics';
import Conditions from './containers/Conditions/Conditions';
import Attachments from './containers/Attachments/Attachments';
import Locations from './containers/Locations/Locations';
import Registries from './containers/Registries/Registries';
import AnalyticsDashboard from './containers/Analytics/DjangoAnalytics/AnalyticsDashboard';
import Users from './containers/Users/Users';
import AllCTGList from './containers/AllCTGList/AllCTGList'
import NotFound from './containers/NotFound/NotFound';
import CTGStudyDetails from './containers/CTGStudyDetails/CTGStudyDetails';
import 'react-toastify/dist/ReactToastify.css'
import Clients from './containers/Clients/Clients';
import USERTYPES from './constants/usertypes';
import Languages from './containers/Languages/Languages';
import CommercialProducts from './containers/CommercialProduct/CommercialProducts';
import DevelopmentStatuss from './containers/DevelopmentStatus/DevelopmentStatus';
import { getCookie } from './api/helpers';
import { isExpired } from "react-jwt"
import { getUserInfo } from './api/auth-api';

const App = () => {
  const [isAuth, setAuth] = useState(null);
  const [usertype, setUsertype] = useState(null);
  const {client} = useParams()
  // const [user, setUser] = useState(
  //   {
  //     first_name: '',
  //     last_name: '',
  //     permissions: ['user.edit', 'user.create']
  //   }
  // );

  useEffect(() => {
      let accessToken = getCookie('access')
      if (accessToken) {
        console.log(isExpired(accessToken))
        if (!isExpired(accessToken)){
          console.log('here?')
          setAuth(true)
        }
        else{
          console.log('there')
          setAuth(false)
        }
      }
      else{
        setAuth(false)
      }
      return null
  }, []
  );

  useEffect(() => {
    if(isAuth){
      getUserInfo().then(res => {
        // set
        localStorage.setItem('username', res.data?.username)
        localStorage.setItem('client', res.data?.client)
        setUsertype(res.data?.usertype)
        

      })
    }

  }, [isAuth])

  const renderAuthenticatedView = () => {
    return (
      <Routes>
        <Route exact path="/:client" element={<Dashboard usertype={usertype}/>} />
        <Route exact path="/:client/studies" element={<StudyList />} />
        <Route exact path="/:client/global-registries" element={<GlobalRegistries />} />
        <Route exact path="/:client/interventions" element={<Interventions />} />
        <Route exact path="/:client/studies/:id" element={<StudyDetails />} />
        <Route exact path="/:client/conditions" element={<Conditions />} />
        <Route exact path="/:client/attachments" element={<Attachments />} />
        <Route exact path="/:client/locations" element={<Locations />} />
        <Route exact path="/:client/study-registries" element={<Registries />} />
        <Route exact path="/:client/registries" element={<Registries />} />
        <Route exact path="/:client/analytics" element={<Analytics />} />
        <Route exact path="/:client/users" element={<Users />} />
        <Route exact path="/:client/analytics-dashboard" element={<AnalyticsDashboard />} />
        {(usertype === USERTYPES.super_admin && (localStorage.getItem('client') === 'public' || localStorage.getItem('client') === 'xogene')) &&
          <Route exact path="/:client/clients" element={<Clients />} />
        }

        <Route exact path="/:client/ctg-studies" element={<AllCTGList />} />
        <Route exact path="/:client/ctg-studies/:id" element={<CTGStudyDetails />} />
        <Route exact path="/:client/languages" element={<Languages />} />
        <Route exact path="/:client/commercial-products" element={<CommercialProducts />} />
        <Route exact path="/:client/development-status" element={<DevelopmentStatuss />} />
                {/* <Route exact path="/:client/global-registries" element={<GlobalRegistries />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    )
  }

  const renderNonAuthenticatedView = () => {
    return (
      <Routes>
        <Route exact path="/:client" element={
          <Login
            isAuth={isAuth}
            setAuth={setAuth}
            setUsertype={setUsertype}
            // setUser={setUser}
          />
          }/>

        <Route exact path="/:client/reset-password"
          element={ <ResetPassword isAuth={isAuth}/> }/>

        <Route exact path="/:client/reset-password/confirm/:userid/:token"
          element={<ResetPasswordConfirm isAuth={isAuth}/>}/>

        <Route path="*" element={<NotFound />} />
      </Routes>
    )
  }

  return (
    <Container>
      <NavbarContainer>
        <Navbar
          // user={user}
          // setUser={setUser}
          isAuth={isAuth}
          setAuth={setAuth} />
      </NavbarContainer>

      <ContentContainer device>
        <RouteContainer useResponsiveOffset={false}>
          {isAuth === null ? <Loading /> :
            isAuth === true ?
              renderAuthenticatedView() :
              renderNonAuthenticatedView()
          }
        </RouteContainer>
      </ContentContainer>

      <ToastContainer />
    </Container>
  );
}

export default App;

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #F5F6FA;
`

const NavbarContainer = styled.div`
  height: 4em;
  width: 100%
`

const ContentContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
`

const RouteContainer = styled.div`
  width: 100%;
  height: 100%;
`
